import axios from "axios";
import config from "../config";

const apiURL = config("API_URL");

const SearchServices = {
  async getEvents(
    query,
    locale,
    country,
    region,
    dateRefinementObj,
    onlineOnly
  ) {
    const response = await axios.get(`${apiURL}/search/${country}/${region}`, {
      params: {
        query,
        locale,
        dateRefinementObj,
        onlineOnly
      }
    });
    return response.data;
  },
  async getTags(userId, locale) {
    const response = await axios.get(`${apiURL}/search/tags/${userId}`, {
      params: {
        locale
      }
    });
    return response.data.tags;
  }
};

export default SearchServices;
